import React from 'react';
import {
  Grid,
  Switch,
  TextField,
  Divider
} from '@material-ui/core';


const GalleryDisplay = ({values, onChange}) => {
  const { display } = values;

  return (
    <div>
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Show Surgeon Filter</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            checked={display.show_surgeon_filter == 1}
            onChange={(event) => onChange('display.show_surgeon_filter', event.target.checked ? 1 : 0)}
          />
        </Grid>
        {display.show_surgeon_filter == 1 &&
          <>
            <Grid item xs={12} sm={2} className="my-2 ml-4">Surgeon Filter Label</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                className="w-full max-w-450"
                variant="outlined"
                size="small"
                value={display.surgeon_filter_label}
                onChange={(event) => onChange('display.surgeon_filter_label', event.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="my-2 ml-4">&quot;All Surgeons&quot; Option Label</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                className="w-full max-w-450"
                variant="outlined"
                size="small"
                value={display.surgeon_filter_all_label}
                onChange={(event) => onChange('display.surgeon_filter_all_label', event.target.value)}
              />
            </Grid>
          </>
        }
        <Grid item xs={12} sm={2} className="my-2 ml-4">Show Tag Filter</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            checked={display.show_tag_filter == 1}
            onChange={(event) => onChange('display.show_tag_filter', event.target.checked ? 1 : 0)}
          />
        </Grid>
        {display.show_tag_filter == 1 &&
          <>
            <Grid item xs={12} sm={2} className="my-2 ml-4">Tag Filter Label</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                className="w-full max-w-450"
                variant="outlined"
                size="small"
                value={display.tag_filter_label}
                onChange={(event) => onChange('display.tag_filter_label', event.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="my-2 ml-4">&quot;All Tags&quot; Option Label</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                className="w-full max-w-450"
                variant="outlined"
                size="small"
                value={display.tag_filter_all_label}
                onChange={(event) => onChange('display.tag_filter_all_label', event.target.value)}
              />
            </Grid>
          </>
        }
      </Grid>
      <Divider className="my-8" />
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Show Item Attributes</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            checked={display.show_attributes == 1}
            onChange={(event) => onChange('display.show_attributes', event.target.checked ? 1 : 0)}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Show Item Titles</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            checked={display.show_item_titles == 1}
            onChange={(event) => onChange('display.show_item_titles', event.target.checked ? 1 : 0)}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">&quot;Before&quot; Label</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            className="w-full max-w-450"
            variant="outlined"
            size="small"
            value={display.before_label}
            onChange={(event) => onChange('display.before_label', event.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">&quot;After&quot; Label</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            className="w-full max-w-450"
            variant="outlined"
            size="small"
            value={display.after_label}
            onChange={(event) => onChange('display.after_label', event.target.value)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default GalleryDisplay;
